var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('nuxt-link',{class:['site-title', { test: _vm.isTest }],attrs:{"to":{ name: _vm.getToPage }}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"LikeCoin"}}),_vm._v(" "),(_vm.isTest)?_c('span',{staticClass:"sup"},[_vm._v("\n      "+_vm._s(_vm.$t('Store.Header.label.test'))+"\n    ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }